import React, { Component } from "react";
import { Link } from "react-router-dom";
import HasPermissionTo from "../../common/HasPermissionTo";
import { withTranslation } from "react-i18next";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import fordStyles from "./Footer.module.scss";
import lincolnStyles from "./Footer-Lincoln.module.scss";

let isFordBrand = true;
let styles = fordStyles;

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
    };
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      openModal: !prevState.openModal,
    }));
  };
  updateStyles = (isFordBrand = true) => {
    styles = isFordBrand ? fordStyles : lincolnStyles;
  };

  render() {
    if (this.props.user && this.props.user.brand) {
      isFordBrand = IS_FORD_BRAND(this.props.user.brand);
    }
    this.updateStyles(isFordBrand);

    return (
      <div className={styles.footerBox} data-testid="appFooter">
        <div className={styles.footerTitleBox}>{this.props.footerTitle}</div>
        <div className={styles.helpContainer}>
          <HasPermissionTo
            perform={["helpAndSupportLink"]}
            condition={this.props.isDealer || this.props.fromNscDealerSearch}
            permissions={this.props.permissions.rolePermissions}
            render={() => (
              <Link
                to={{
                  pathname: "/help",
                }}
              >
                {this.props.helpSupportTitle}
              </Link>
            )}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation("emp")(Footer);
